module.exports = __webpack_public_path__ + "img/default.887f1047.png";